import * as React from 'react';

import { ICON_MARKER } from './iconMarker';

// Not in icons.tsx, which imports the theme: the theme imports these for MUI's checkboxes and radios.

export function CheckboxEmptyIcon({
    size = 'large',
    ...props
}: { size?: 'large' | 'small' } & React.SVGProps<SVGSVGElement>): JSX.Element {
    const heightAndWidth = size === 'large' ? '20' : '16';
    return (
        <svg
            {...ICON_MARKER}
            width={heightAndWidth}
            height={heightAndWidth}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            // The checkbox or radio input carries the state, as with MUI's own icons.
            aria-hidden="true"
            {...props}
        >
            <rect x="1" y="1" width="18" height="18" rx="3" fill="none" />
            <rect
                x="1"
                y="1"
                width="18"
                height="18"
                rx="3"
                stroke={'currentColor'}
                strokeWidth="2"
                strokeMiterlimit="6.69898"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export function CheckboxCheckedIcon({
    size = 'large',
    ...props
}: { size?: 'large' | 'small' } & React.SVGProps<SVGSVGElement>): JSX.Element {
    const heightAndWidth = size === 'large' ? '20' : '16';
    return (
        <svg
            {...ICON_MARKER}
            width={heightAndWidth}
            height={heightAndWidth}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect width="20" height="20" rx="4" fill={'currentColor'} />
            <path
                d="M15.7801 6.62576C16.1256 6.19491 16.0565 5.56552 15.6257 5.22C15.1949 4.87441 14.5655 4.94351 14.2199 5.37429L8.53535 12.4611L5.73995 9.38619C5.36845 8.9775 4.73599 8.94741 4.32734 9.31893C3.91868 9.69039 3.88856 10.3228 4.26006 10.7315L7.84296 14.6727C8.03973 14.8891 8.3214 15.0086 8.61378 14.9995C8.90615 14.9905 9.17992 14.8539 9.36295 14.6258L15.7801 6.62576Z"
                fill="white"
            />
        </svg>
    );
}

export function CheckboxIndeterminateIcon({
    size = 'large',
    ...props
}: { size?: 'large' | 'small' } & React.SVGProps<SVGSVGElement>): JSX.Element {
    const heightAndWidth = size === 'large' ? '20' : '16';
    return (
        <svg
            {...ICON_MARKER}
            width={heightAndWidth}
            height={heightAndWidth}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect width="20" height="20" rx="4" fill={'currentColor'} />
            <path
                d="M6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11H14C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9H6Z"
                fill="white"
            />
        </svg>
    );
}

export function RadioEmptyIcon({
    size = 'large',
    ...props
}: { size?: 'large' | 'small' } & React.SVGProps<SVGSVGElement>): JSX.Element {
    const heightAndWidth = size === 'large' ? '20' : '16';
    return (
        <svg
            {...ICON_MARKER}
            width={heightAndWidth}
            height={heightAndWidth}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect x="1" y="1" width="18" height="18" rx="9" stroke={'currentColor'} strokeWidth="2" />
        </svg>
    );
}

export function RadioCheckedIcon({
    size = 'large',
    ...props
}: { size?: 'large' | 'small' } & React.SVGProps<SVGSVGElement>): JSX.Element {
    const heightAndWidth = size === 'large' ? '20' : '16';
    return (
        <svg
            {...ICON_MARKER}
            width={heightAndWidth}
            height={heightAndWidth}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <rect x="2" y="2" width="16" height="16" rx="9" stroke={'currentColor'} strokeWidth="4" />
        </svg>
    );
}
